import React from 'react';
import PioneersSection from '../components/About/PioneersSection';
import AssociationsSection from '../components/About/AssociationsSection';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Institute/DSC_3657.JPG";

const About = () => {
  return (
    <>
  <UniqueBanner
  image={BannerImg}
  title="Primary Teacher Training"
  subtitle="Training teachers since 2004 with excellence and placement support."
/>
    <PioneersSection />
    <AssociationsSection />
    </>
  );
};

export default About;
